var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnAlbum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6.57855V15.4085C21 18.6804 18.9523 20.9881 15.6804 20.9881H6.30878C3.03684 20.9881 1 18.6804 1 15.4085V6.57855C1 3.30661 3.04767 1 6.30878 1H15.6804C18.9523 1 21 3.30661 21 6.57855Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74255 15.8229L5.39911 14.0754C5.99608 13.4448 6.99824 13.4416 7.60063 14.0667L8.55946 15.045C9.20626 15.7048 10.2821 15.6572 10.8682 14.9432L13.2832 12.006C13.9766 11.162 15.2485 11.11 16.008 11.8934L18.2572 14.214",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19532 7.91595C9.19532 8.9647 8.34375 9.81627 7.29499 9.81627C6.24624 9.81627 5.39575 8.9647 5.39575 7.91595C5.39575 6.8672 6.24624 6.01562 7.29499 6.01562C8.34375 6.01562 9.19532 6.8672 9.19532 7.91595Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAlbum);
export default __webpack_public_path__ + "static/media/icn-album.bccd137884dc08cb8048d07c36c9e9cb.svg";
export { ForwardRef as ReactComponent };